import React, { useEffect, useState } from "react";
import { notificationEmitter } from "../../utils/notificationEmitter";
import AlertModal from "./AlertModal";
import ToastNotification from "./ToastNotification";

/**
 * Global notification handler that listens to notification events.
 *
 * Success/info notifications are confirmations of something that already
 * worked — they get the non-blocking toast (top-right, auto-hides). Errors
 * and warnings still get the AlertModal, because those need an explicit
 * acknowledgement before the user carries on.
 */
const GlobalNotificationHandler = () => {
  const [notification, setNotification] = useState(null);

  useEffect(() => {
    const unsubscribe = notificationEmitter.subscribe((notif) => {
      setNotification(notif);
    });

    return unsubscribe;
  }, []);

  const handleClose = () => {
    setNotification(null);
  };

  if (!notification) return null;

  const isToast =
    notification.type === "success" || notification.type === "info";

  if (isToast) {
    return (
      <ToastNotification
        isOpen
        title={notification.title || ""}
        message={notification.message || ""}
        tone={notification.type}
        onClose={handleClose}
      />
    );
  }

  // Map notification types to AlertModal tones
  const toneMap = {
    error: "danger",
    warning: "warning",
  };

  return (
    <AlertModal
      isOpen
      title={notification.title || "Notification"}
      message={notification.message || ""}
      tone={toneMap[notification.type] || "info"}
      hideCancel={true}
      confirmLabel="OK"
      onConfirm={handleClose}
      onClose={handleClose}
    />
  );
};

export default GlobalNotificationHandler;
